<template>
  <div>
    <!--底部导航-->
    <a-row>
      <a-col>
        <div class="footer-wrapper">
          <div class="content-warpper">
            <div class="copyright-wrapper">
              <div class="copyright-info">
                <span
                  >版权所有：云采链（广州）信息科技有限公司&nbsp;&nbsp;&nbsp;&nbsp;技术支持：云采链（广州）信息科技有限公司</span
                >
                <span>Copyright © 2016 All Rights Reserved </span>
                <a href="http://beian.miit.gov.cn" style="padding-left: 15px"
                  >粤ICP备17133418号</a
                >
                <br />
                <span>所有内容未经授权，不得转载或做其他使用，违者必究</span>
              </div>

              <div class="qrcode">
                <img src="./images/qrCode.jpg" class="img-code" />
                <img src="./images/qrcode-tips.png" height="69" width="136" />
              </div>
            </div>
          </div>
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
export default {
  data () {
    return {}
  },
  methods: {}
}
</script>

<style lang="less" scoped>
.footer-wrapper {
  background: #fff;
  min-width: 1220px;
  margin: 0 auto;
  padding: 10px;
  .content-warpper {
    margin: 0 auto;
  }
  .copyright-wrapper {
    display: flex;
    justify-content: space-around;
    .copyright-info {
      display: inline-block;
      vertical-align: top;
      text-align: left;
      width: 580px;
      line-height: 24px;
      color: #333;
      margin-top: 10px;
      margin-left: 50px;
      a {
        color: #227ee9;
      }
      a:hover {
        text-decoration: underline;
      }
    }
    .qrcode {
      display: inline-block;
      vertical-align: top;
      margin-left: 330px;
      .img-code {
        width: 90px;
        height: 90px;
      }
    }
  }
}
</style>
